export const DISPLAY_SIZE = {
  xl: "xl",
  lg: "lg",
  md: "md",
  sm: "sm",
  xs: "xs",
} as const

export type DisplaySize = keyof typeof DISPLAY_SIZE

export const ASSETS_BASE_URL = "https://assets.placepoint.no"
export const ASSETS_FLAG_DIR = "images/icons/flags"
export const ASSETS_BUILDING_PRESETS_DIR =
  "images/thumbnails/3d/preset-building"
